export const debounce = (func, time = 300, args = []) => {
  let timeout;

  return function () {
    const funcCall = () => {
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(funcCall, time);
  };
};
